import { errorToast, successToast } from '@components/toasts/Toasts';
import { ApiError } from '@shared/api/errors';
import { reportAppError } from '@shared/reportAppError';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { SETTINGS_LIGHTSPEED_PATH } from 'restaurantAdmin/paths';
import { SettingsOutletHeader } from '../shared/SettingsOutletHeader';
import { completeLightspeedOAuth } from './apiHelpers';
import styles from './LightspeedOAuthCallbackPage.scss';

export const LightspeedOAuthCallbackPage = () => {
  const restaurant = useRestaurant();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Completing Lightspeed connection…');

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const oauthError = searchParams.get('error');
    const oauthErrorDescription = searchParams.get('error_description');

    const run = async () => {
      if (oauthError) {
        const detail = oauthErrorDescription ?? oauthError;
        errorToast({
          message: `Lightspeed sign-in was not completed (${detail}).`,
        });
        setMessage('Lightspeed sign-in was canceled or failed.');
        return;
      }

      if (!code || !state) {
        errorToast({
          message: 'Missing authorization information from Lightspeed.',
        });
        setMessage('Missing authorization information. Try Connect again.');
        return;
      }

      try {
        await completeLightspeedOAuth(restaurant.id, { code, state });

        successToast({
          message: 'Lightspeed is connected for this restaurant.',
        });
        navigate(SETTINGS_LIGHTSPEED_PATH, { replace: true });
      } catch (error) {
        if (error instanceof ApiError) {
          errorToast({ message: error.message });
          setMessage(error.message);
        } else {
          errorToast({
            message: 'Could not complete Lightspeed connection.',
          });
          setMessage('An unexpected error occurred.');
          reportAppError(error);
        }
      }
    };

    void run();
  }, [navigate, restaurant.id, searchParams]);

  return (
    <div className={styles.root}>
      <SettingsOutletHeader title="Lightspeed" />
      <p>{message}</p>
    </div>
  );
};
